import React from 'react'
import Responsive from 'react-responsive'

const Desktop = props => <Responsive {...props} minWidth={992} />
const Tablet = props => <Responsive {...props} minWidth={768} maxWidth={991} />
const Mobile = props => <Responsive {...props} maxWidth={767} />
const Default = props => <Responsive {...props} minWidth={768} />

const isTablet = () =>
  typeof window !== 'undefined' &&
  window.innerWidth < 992 &&
  window.innerWidth > 767
const isNarrowDesktop = () =>
  typeof window !== 'undefined' && window.innerWidth < 1200

const isMobile = () => typeof window !== 'undefined' && window.innerWidth < 767

export { Desktop, Tablet, Mobile, Default, isTablet, isNarrowDesktop, isMobile }



// WEBPACK FOOTER //
// ./src/media-queries.js